module.exports = __webpack_public_path__ + "static/media/logo-color_with_planet.486ba5d0.png";